import { Add, Clickable, Icon, Row } from 'components';
import React, { useState } from 'react';

const AddButton = ({}) => {
  const [visible, setVisible] = useState(false);

  return (
    <React.Fragment>
      <Add visible={visible} setVisible={setVisible} />

      <Clickable onClick={() => setVisible(true)}>
        <Row centerAll wid="40px" ht="40px" bg="#000" hasRadius="20px">
          <Icon type="add" col="#fff" dimensions={14} />
        </Row>
      </Clickable>
    </React.Fragment>
  );
};

export default AddButton;
